/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { makeAutoObservable } from 'mobx';

import { syncCredentialsWithLocalStorage } from 'App/Pages/Diagram/features/deployment/remember-credentials';

import configuredClustersService from './ConfiguredClustersService';

class ConfiguredClustersStore {
  clusters = [];

  constructor() {
    makeAutoObservable(this);
  }

  async load() {
    try {
      this.clusters = await configuredClustersService.fetchClusters();
      syncCredentialsWithLocalStorage(this.clusters);
    } catch (ex) {
      console.error('Failed to load configured clusters!');
      console.error(ex);
    }
  }

  get isClustersConfigured() {
    return this.clusters?.length > 0;
  }
}

export default new ConfiguredClustersStore();
